import { ElMessage, ElMessageBox, ElInput } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import useFavorite from './composables/useFavorite';
import bus from '@/utils/eventBus';
export default {
  name: 'nav-tree',
  setup() {
    const defaultProps = {
      label: 'name',
      children: 'children'
    };
    const show = ref(false);
    const form = ref({});
    let currentData = {};
    let operation = ref('add');
    const router = useRouter();
    const {
      data,
      queryFavorite,
      addFavorite,
      updateFavorite,
      delFavorite
    } = useFavorite();
    onMounted(() => {
      queryFavorite();
      bus.on('collection-refresh', () => queryFavorite());
    });
    const nodeClick = data => {
      router.push(`/assets-lib/collection?favId=${data.id}`);
    };
    const operateHandler = (type, data) => {
      operation.value = type;
      currentData = data;
      show.value = true;
      if (type === 'add') form.value.name = '';
      if (type === 'update') form.value.name = data.name;
    };
    const confirmHandler = () => {
      if (operation.value === 'add') {
        let json = {
          name: form.value.name,
          parentId: currentData.id
        };
        addFavorite(json).then(() => show.value = false);
      } else {
        let json = {
          name: form.value.name,
          id: currentData.id,
          parentId: currentData.parentId
        };
        updateFavorite(json).then(() => {
          show.value = false;
        });
      }
    };
    const delHandler = data => {
      console.log(data, "data");
      if (data.def) {
        ElMessage.warning("默认收藏夹不能删除");
        return;
      }
      ElMessageBox.confirm('确定要删除该收藏夹吗？').then(() => {
        delFavorite(data.id).then(() => {
          ElMessage.success("删除成功");
        });
      }).catch(() => {});
    };
    return {
      defaultProps,
      data,
      show,
      form,
      operation,
      nodeClick,
      operateHandler,
      confirmHandler,
      delHandler,
      delFavorite,
      ElInput
    };
  }
};